import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTerminalDeNetPay,
  getTerminalesDeNetPay,
  patchTerminalDeNetPay,
  postTerminalDeNetPay,
} from 'api/configuracion/terminalDeNetPay';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';

// eslint-disable-next-line react/prop-types
const TerminalDeNetPay = ({ permission }) => (
  <>
    <PlainCRUD
      title="Terminal de NetPay"
      permission={permission}
      withoutState
      get={getTerminalesDeNetPay}
      post={postTerminalDeNetPay}
      patch={patchTerminalDeNetPay}
      delete={deleteTerminalDeNetPay}
      fields={[
        defaultFields.clave,
        defaultFields.descripcion,
        {
          label: 'Fecha de Asignación',
          name: 'fecha_de_asignacion',
          colWidth: 300,
          required: true,
          render: (val) => val?.format?.(DATE_FRONTEND_FORMAT),
          type: 'date',
        },
        {
          label: 'Identificador',
          name: 'identificador',
          colWidth: 200,
          required: true,
        },
        {
          label: 'Serial',
          name: 'serial',
          colWidth: 200,
          required: true,
        },
        {
          label: 'Comentarios',
          name: 'comentarios',
          colWidth: 400,
          required: true,
          type: 'textarea',
          autoSize: { minRows: 3, maxRows: 4 },
        },
      ]}
    />
  </>
);

export default TerminalDeNetPay;
